import { Empty, Table, Tabs } from "antd";
import React from "react";

const RATIO_TIMESPAN_TITLES = {
  all: "Ending Avg",
  last7: "7 Day Avg",
  last14: "14 Day Avg",
  last30: "30 Day Avg",
};

const order = {
  all: 0,
  last7: 1,
  last14: 2,
  last30: 3,
};

export default function TableGroup({ title, ratios, columns }) {
  return (
    <>
      <h3 style={{ marginBottom: 25 }}>{title}</h3>

      <Tabs defaultActiveKey="all">
        {Object.keys(ratios)
          .sort((a, b) => order[a] > order[b])
          .map((timespan) => {
            return (
              <Tabs.TabPane tab={RATIO_TIMESPAN_TITLES[timespan]} key={timespan}>
                {ratios[timespan].length === 0 && <Empty />}
                {ratios[timespan].length > 0 && (
                  <Table
                    className={"player-charts-ratios ant-table-mobile"}
                    columns={columns(timespan)}
                    dataSource={ratios[timespan]}
                    scroll={{ y: "80vh", x: true }}
                    pagination={{ pageSize: 50, showSizeChanger: true, showQuickJumper: true }}
                  />
                )}
              </Tabs.TabPane>
            );
          })}
      </Tabs>
    </>
  );
}
